export const GENERIC_SYSTEM_ERROR =
  "Ha ocurrido un error inesperado en el sistema. Por favor, intente nuevamente. Si el problema persiste, contacte al administrador.";

export const isEmpty = (v) =>
  v === null || v === undefined || (typeof v === "string" && v.trim() === "");

/**
 * Formatea un error recibido desde un catch que involucra llamadas axios.
 * 
 * Reglas:
 * 1) Si el error es un string → se retorna tal cual.
 * 2) Si viene de Axios, intenta obtener el mensaje desde las rutas más comunes:
 *    - error.response.data.error.message
 *    - error.response.data.message
 *    - error.response.data (si es texto plain o un objeto simple)
 *    - error.message (mensaje estándar de JS / Axios)
 * 3) Si nada coincide, devuelve un mensaje por defecto.
 */
export function formatAxiosError(error, fallbackMsg = GENERIC_SYSTEM_ERROR) {
  // Caso 1: el error es un string. Ej: throw "Algo falló".
  if (typeof error === "string") {
    return error;
  }

  // Caso 2: Axios envía información dentro de error.response
  const axiosMessage =
    error?.response?.data?.error?.message || // Formato típico de errores API estandarizadas
    error?.response?.data?.message ||        // Mensaje directo desde el backend
    (typeof error?.response?.data === "string"
      ? error.response.data
      : null);                               // Cuando el backend devuelve texto puro

  if (axiosMessage) {
    return axiosMessage;
  }

  // Caso 3: error.message captura errores como:
  // - Timeouts
  // - Network Error
  // - Excepciones del runtime
  if (error?.message) {
    return error.message;
  }

  // Caso 4: fallback final
  return fallbackMsg;
}

export function formatAntdFormError(errorInfo) {
  if (!errorInfo?.errorFields?.length) {
    return null;
  }

  // Unir todos los mensajes en uno solo
  return errorInfo.errorFields
    .map(field => field.errors.join(", "))
    .join("\n");

}

export function showAntdFormError(errorInfo) {
  const message = formatAntdFormError(errorInfo);

  if (!message) return;

  window.messageApi.error(message, { modal: true })
}